module.exports = "/images/page-bg-bottom.png?ec613ada298590517b55ec1e07aaa754";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/assets/images/page-bg-bottom.png
// module id = qZvP
// module chunks = 35